import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize as crs, onDesktop, p} from "@pg-design/helpers-css";

import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {mobileSearchTriggerHeight} from "../../../search/constants/mobile_search_trigger_height";
import {MapLayerButtons} from "./MapLayerButtons";

export function MapLayersBox(props: {transportRoutes: IOSMPoisRoutesGrouped[] | null}) {
    //  TODO: In the next stage of map changes (price layers), make price props mandatory and adjust cod

    return (
        <div css={mapLayersBox}>
            <MapLayerButtons transportRoutes={props.transportRoutes} />
        </div>
    );
}

const mapLayersBox = (theme: Theme) => css`
    background: ${theme.colors.gray[200]};
    width: 100%;
    ${p(1, 1.5)};
    position: fixed;
    bottom: ${mobileSearchTriggerHeight};
    display: none;

    ${onDesktop(css`
        display: flex;
        position: absolute;
        left: ${crs(3)};
        bottom: ${crs(3)};
        ${borderRadius(2)};
        width: auto;
    `)}
`;
import {css, Theme} from "@emotion/react";

import {borderRadius, calculateRemSize as crs, onDesktop, p} from "@pg-design/helpers-css";

import {IOSMPoisRoutesGrouped} from "../../../maps/actions/fetch_osm_pois_routes_grouped";
import {mobileSearchTriggerHeight} from "../../../search/constants/mobile_search_trigger_height";
import {MapLayerButtons} from "./MapLayerButtons";

export function MapLayersBox(props: {transportRoutes: IOSMPoisRoutesGrouped[] | null}) {
    //  TODO: In the next stage of map changes (price layers), make price props mandatory and adjust cod

    return (
        <div css={mapLayersBox}>
            <MapLayerButtons transportRoutes={props.transportRoutes} />
        </div>
    );
}

const mapLayersBox = (theme: Theme) => css`
    background: ${theme.colors.gray[200]};
    width: 100%;
    ${p(1, 1.5)};
    position: fixed;
    bottom: ${mobileSearchTriggerHeight};
    display: none;

    ${onDesktop(css`
        display: flex;
        position: absolute;
        left: ${crs(3)};
        bottom: ${crs(3)};
        ${borderRadius(2)};
        width: auto;
    `)}
`;
